import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';
import BookmarkRemoveOutlinedIcon from '@mui/icons-material/BookmarkRemoveOutlined';
import { ListItemIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useIsFavorite } from './hooks';

import type { FC } from 'react';

export const ToggleFavorite: FC = () => {
  const { t } = useTranslation();
  const isFavorite = useIsFavorite();

  if (isFavorite) {
    return (
      <>
        <ListItemIcon>
          <BookmarkRemoveOutlinedIcon />
        </ListItemIcon>
        <Typography variant="inherit">
          {t('GSP.pages.parentHelper.history.menu.removeFromFavorites')}
        </Typography>
      </>
    );
  }

  return (
    <>
      <ListItemIcon>
        <BookmarkAddOutlinedIcon />
      </ListItemIcon>
      <Typography variant="inherit">
        {t('GSP.pages.parentHelper.history.menu.addToFavorites')}
      </Typography>
    </>
  );
};
